var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.65,
    y: 2.65,
    width: 26.7,
    height: 26.7,
    rx: 13.35,
    fill: "#6C727E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.581 20.258-3.585-5.09-.405-.575-2.565-3.641-.212-.302h-3.152l.769 1.091 3.41 4.842.405.575 2.74 3.89.213.302h3.15l-.768-1.092Zm-2.008.395-2.846-4.041-.406-.576-3.303-4.69h1.42l2.672 3.793.405.575 3.479 4.939h-1.421Z",
    fill: "#16191F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.321 16.036.406.576-.48.546-3.688 4.192h-.91l4.192-4.767.48-.547ZM20.97 10.65l-3.974 4.518-.48.546-.406-.575.48-.546 2.693-3.062.779-.881h.909Z",
    fill: "#16191F"
  })));
};
export default SvgTwitter;